// extracted by mini-css-extract-plugin
export default {"imagecontainer":"styles_imagecontainer__8T+2-","image":"styles_image__rdq9n"};